import { render } from "./NewVideo.vue?vue&type=template&id=97ed3e8a"
import script from "./NewVideo.vue?vue&type=script&lang=js"
export * from "./NewVideo.vue?vue&type=script&lang=js"

import "./NewVideo.vue?vue&type=style&index=0&id=97ed3e8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__